import { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/material';

// Components
import { NoResultsCard } from 'components/NoResultsCard';
import { BoardListTable } from './BoardListTable';
import { LoadingCards } from 'components/LoadingCard';

// Core + Store
import { getBoardList } from 'store/bct/actions';
import { boardListSelector, isLoadingBCTSelector } from 'store/bct/selectors';
import { ThunkDispatch } from 'redux-thunk';
import { AppState } from 'store';

// Types
import { IBoardSlim, PARSAction } from 'core/models';

export const BoardListPage = (): ReactElement => {
  const dispatch: ThunkDispatch<AppState, unknown, PARSAction> = useDispatch();

  // Selectors.
  const boardList: IBoardSlim[] = useSelector(boardListSelector);
  const isLoading: boolean = useSelector(isLoadingBCTSelector);

  useEffect(() => {
    if (!boardList) {
      dispatch(getBoardList());
    }
  }, [boardList, dispatch]);

  // Show this when we're waiting for results.
  const isPending = isLoading && <LoadingCards />;

  // Show this when we don't have any results.
  const noResults: ReactElement = !!boardList?.length && <NoResultsCard />;

  // Show this when we have results.
  const hasResults = !!boardList?.length && <BoardListTable results={boardList} />;

  return (
    <Grid component="section" className="summary-container">
      <Grid sx={{ alignContent: 'space-between' }} size={{ xs: 12 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <h1 className="title">Board List</h1>
          {hasResults && `${boardList.length} results`}
        </Box>
      </Grid>
      {/* Render the main content. */}
      <Grid size={{ xs: 12 }}>{hasResults || isPending || noResults}</Grid>
    </Grid>
  );
};
